define([
    "dojo/_base/declare",
    "csi/action/Controller",
    "csi/xml"
], function(declare,Controller,xml) {

    return declare(Controller, {
        toWriterRequest: function() {
            // summary: pass query to java method to cancel offline all the quotes in the view
            var store = this.widget.get("store");
            var query = this.widget.getQueryResultQuery();
            var storeRequest = store.getRequest(query, null, true);

            var call = this.inherited(arguments);
            call.addParameter("Query", xml.ATTR_STRING, storeRequest.binaryValue);
            call.addParameter("QueryLimitPath", xml.ATTR_STRING, storeRequest.getParameter("Qry.Limit.Path"));

            return call;
        }
    });
});